import { Typography, Grid } from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ArticleIcon from "@mui/icons-material/Article";
import ChatIcon from '@mui/icons-material/Chat';
import { styles, iconStyle } from "./glossaryData.styles";

const iconEye = <RemoveRedEyeIcon style={iconStyle} />;
const iconChat = <ChatIcon style={iconStyle} />;

export const pediatricGlossaryData = (t) => ({
  rows: [
    {
      parameter: "name",
      detail: "complete_name_patient",
      behavior: "-",
      align: { behavior: "center" },
    },
    {
      parameter: "antiquity",
      detail: "time_elapsed_enrollment",
      behavior: "-",
      align: { behavior: "center" },
    },
    {
      parameter: "weekly_adherence",
      detail: "reported_as_percentage",
      behavior: (
        <Typography sx={styles.cells}>
          {t("load_percentage")}
          <br />• {t("if_load_porcentage_elderly_70")} "
          <span style={styles.success}>75%</span>"
          <br />• {t("if_porcentage_elderly_40")} "
          <span style={styles.warning}>60</span>%"
          <br />• {t("if_porcentage_minor_40")}
          <span style={styles.error}> 35</span>%" <br />
          {t("example")}"🟢<span style={styles.success}> 71</span>%"
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "last_load",
      detail: "last_charge_time",
      behavior: (
        <Typography sx={styles.cells}>
          • {t("no_data_last_two_month")}{" "}
          <span style={styles.error}>{t("greater_than_two")}</span> <br />•
          {t("if_load_al_least_one")}
          <span style={styles.success}>{t("sixteen_hours")}</span> • <br />
          {t("if_load_more_than_two_days")}
          <span style={styles.error}>{t("four_days")}</span> <br />
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: { text: "fc_today", subtext: "frequency_today" },
      detail: "show_fc",
      behavior: (
        <Typography sx={styles.cells}>
          • {t("no_data")}: -- <br />
          {t("with_data_porcentage_color")} <br />•{" "}
          {t("if_data_larger_than_fifty")} "
          <span style={styles.success}>65</span>" <br />•
          {t("data_minor_than_fifty")}"<span style={styles.error}>95</span>"
        </Typography>
      ),
      align: { behavior: "justify" },
    },
    {
      parameter: { text: "fr_today", subtext: "respiratory_today" },
      detail: "show_fr",
      behavior: (
        <Typography sx={styles.cells}>
          • {t("no_data")}: --
          <br /> {t("with_data_porcentage_color")}
          <br />• 🟢 {t("value_inside_expected")}
          <br />• 🔴 {t("value_outside_expected")}
        </Typography>
      ),
      align: { behavior: "justify" },
    },
    {
      parameter: { text: "so_today", subtext: "saturation_today" },
      detail: "show_so",
      behavior: (
        <Typography sx={styles.cells}>
          • {t("no_data")}: --
          <br /> {t("with_data_porcentage_color")}
          <br />• 🟢 {t("value_inside_expected")}
          <br />• 🔴 {t("value_outside_expected")}
        </Typography>
      ),
      align: { behavior: "justify" },
    },
    {
      parameter: "face_today",
      detail: "show_represetative_face",
      behavior: (
        <Typography sx={styles.cells}>
          • {t("no_data")}:⚪️ <br />• {t("have_registration_day")}
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "actions",
      detail: (
          <Typography sx={styles.cells}>
            <Grid container direction="column" spacing={8}>
              <Grid item xs={6}>
                {t("see")}
                {iconEye} : {t("allows_you_see")}
              </Grid>

              <Grid item xs={6}>
                {t("begin_chat")}
                {iconChat} : {t("glossary_chat_explanation")}
              </Grid>
            </Grid>
          </Typography>
      ),
      behavior: (
        <Typography sx={styles.cells}>
          <Grid container direction="column" spacing={8}>
            <Grid item xs={6} align="justify">
              {t("select_icon_ayes_redirect")}
            </Grid>

            <Grid item xs={6} align="justify">
              {t("glossary_chat_action")}
            </Grid>
          </Grid>
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
  ],
  footerNote: "pediatric_glossary_footer_note",
});
